import { Map } from 'immutable';
import { handleSuccess, mapForPayload } from '../lib/reduxUtils';
import { DELETE_PROJECTS, FETCH_WORKSPACE_PROJECTS, LEAVE_PROJECTS, UPDATE_PROJECT_PROPERTIES } from '../actions/types';

export const workspaceProjects = ( state = new Map(), action ) => {
	switch ( action.type ) {
	case FETCH_WORKSPACE_PROJECTS:
		return handleSuccess(
			state,
			action,
			prevState => prevState
				.merge( mapForPayload( action.payload ) )
		);
	case DELETE_PROJECTS:
		return handleSuccess( state, action, prevState => action.payload.reduce(
			( result, deletedID ) => result.delete( deletedID ),
			prevState
		) );
	case LEAVE_PROJECTS:
		return handleSuccess( state, action, prevState => action.payload.reduce(
			( result, projectID ) => result.update(
				projectID, project => (
					project ? ( { ...project, current_user_role: { type: '-' } } ) : project
				)
			),
			prevState
		) );
	case UPDATE_PROJECT_PROPERTIES: {
		const { projectID } = action.meta;
		const properties = action.payload;

		return state.update( projectID, project => ( { ...project, ...properties } ) );
	}
	default:
		return state;
	}
};
